var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alarm_list" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "alarm-wrapper" }, [
        _c("div", { staticClass: "left-info" }, [
          _c("span", [
            _vm._v(
              _vm._s(_vm.noAnswerNum || 0) +
                "/" +
                _vm._s(_vm.alarmTotalNum || 0)
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "list-box" },
          [
            _vm.table_data.length > 0
              ? _c(
                  "el-carousel",
                  {
                    ref: "carousel",
                    attrs: {
                      arrow: "never",
                      autoplay: false,
                      "indicator-position": "none"
                    }
                  },
                  _vm._l(_vm.table_data, function(item, index) {
                    return _c(
                      "el-carousel-item",
                      { key: index, attrs: { name: _vm.activeIndex } },
                      _vm._l(item, function(_item, _index) {
                        return _c(
                          "div",
                          {
                            key: _index,
                            class: [
                              "list-item",
                              { "item-alarm": _item.alarmStatus === "待处理" }
                            ],
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.alarm_detail(_item)
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "address" }, [
                              _vm._v(_vm._s(_item.deviceName))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "time" }, [
                              _vm._v(_vm._s(_item.time))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "type" }, [
                              _vm._v(_vm._s(_item.alarmName))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "opt" }, [
                              _vm._v(_vm._s(_item.status))
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  }),
                  1
                )
              : _c("div", { staticClass: "tip" }, [_vm._v("设备暂无报警信息")])
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "right-info" }, [
          _c("span", {
            staticClass: "left-slide-arrow",
            on: { click: _vm.leftSwitchEvent }
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "right-slide-arrow",
            on: { click: _vm.rightSwitchEvent }
          })
        ])
      ]),
      _vm._v(" "),
      _c("dialogItem", {
        attrs: { "show-dialog": _vm.showDialog, dialogData: _vm.detail },
        on: { closeDialog: _vm.closeDialog, close_alarm: _vm.close_alarm }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", { staticClass: "left-arrow" }),
      _vm._v(" "),
      _c("span", { staticClass: "title-info" }, [_vm._v("报警信息列表")]),
      _vm._v(" "),
      _c("span", { staticClass: "right-arrow" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79fa8841", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79fa8841","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/main_content/alarm_list.vue
// module id = null
// module chunks = 